import { Contact } from "@/type/core/dashboard/dashboard.types";
import BasicButton from "@components/core/buttons/BasicButton";
import ContactInformationComparisonForm from "@components/core/forms/ContactInformationComparisonForm";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import BasicModal, { BasicModalProps } from "./BasicModal";

interface ContactComparisonModalProps extends BasicModalProps {
  existingContact: Contact;
  contactToAdd: Contact;
  onContactChoose: (contact: Contact) => void;
}

const ContactComparisonModal: FunctionComponent<
  ContactComparisonModalProps
> = ({ existingContact, contactToAdd, onContactChoose, ...props }) => {
  const { t } = useTranslation();

  return (
    <BasicModal
      {...props}
      footer={
        <div className="modal-footer-buttons">
          <BasicButton
            variant="primary"
            text={t("contacts.confirmationContactModal.dbChoice")}
            onClick={() => onContactChoose(existingContact)}
            className="w-100"
          />
          <BasicButton
            variant="primary"
            text={t("contacts.confirmationContactModal.formChoice")}
            onClick={() => onContactChoose(contactToAdd)}
            className="w-100"
          />
        </div>
      }
      title={t("contacts.confirmationContactModal.title")}
      className="modal-lg"
    >
      {contactToAdd && existingContact ? (
        <ContactInformationComparisonForm
          existingContact={existingContact}
          contactToAdd={contactToAdd}
        />
      ) : (
        <></>
      )}
    </BasicModal>
  );
};

export default ContactComparisonModal;
